// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createHook,
	createActionsHook,
	type Action,
} from '@atlassian/react-sweet-state';

export type State = {
	/**
	 * Flag to determine whether the user has clicked on the AI button and is in natural language mode
	 */
	isNaturalLanguageMode: boolean;
};

export type Actions = {
	/**
	 * Event emitted when the user clicks the AI button to either open/close natural language mode
	 */
	toggleNaturalLanguageMode: () => Action<State>;

	/**
	 * Explicitly exit the NL mode (rather than reading the state and then toggle)
	 */
	exitNaturalLanguageMode: () => Action<State>;
};

const initialState: State = {
	isNaturalLanguageMode: false,
};

export const actions: Actions = {
	toggleNaturalLanguageMode:
		() =>
		({ setState, getState }) => {
			setState({ isNaturalLanguageMode: !getState().isNaturalLanguageMode });
		},
	exitNaturalLanguageMode:
		() =>
		({ setState }) => {
			setState({ isNaturalLanguageMode: false });
		},
};

const Store = createStore<State, Actions>({ initialState, actions });

export const Container = createContainer<State, Actions>(Store, {
	onInit:
		() =>
		({ setState }) => {
			setState({
				isNaturalLanguageMode: false,
			});
		},
});

const getNaturalLanguageMode = (state: State): boolean => state.isNaturalLanguageMode;

export const useNaturalLanguageMode = createHook(Store, {
	selector: getNaturalLanguageMode,
});

export const useNlModeStoreActions = createActionsHook(Store);
